module.exports = __webpack_public_path__ + "static/thankunext-baf0f87ac306b8494de71467919a4106.png";